import { useState } from 'react'
import AuthService from 'services/auth'
import cutileiApi from 'services/cutileiApi'
import { logApiError } from 'services/apiError'
import AlertDialog from 'components/AlertDialog'
import { ReactComponent as ButtonLoading } from 'icons/loading2.svg'
import { FaEdit, FaTrash } from 'react-icons/fa'

import {
  Container,
  Header,
  Image,
  Info,
  ButtonRow,
  Button,
  SubTitle,
  MoneyTextMask,
  Description
} from './styles'

export default function CatalogService ({
  data: service,
  catalogID,
  onEdit = () => {},
  onDelete: handleDelete = () => {}
}) {
  const [showAlertDialog, setShowAlertDialog] = useState (false)
  const [deleting, setDeleting] = useState (false)
  const token = AuthService.getToken ()

  const requestConfig = {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  }

  const handleEdit = () => onEdit (service)

  const deleteCatalogService = async () => {
    setDeleting (true)
    try {
      await cutileiApi.delete (
        `/catalogs/${catalogID}/services/${service.id}`, requestConfig
      )

      setDeleting (false)
      handleDelete (service)
    } catch (error) {
      setDeleting (false)
      logApiError (error)
    }
  }

  const toggleAlertDialog = () => setShowAlertDialog (!showAlertDialog)

  return (
    <Container>
      {service.images && service.images.length > 0 && (
        <Image src={service.images[0].image_url} alt={service.name}/>
      )}
      <Info>
        <Header>
          <SubTitle>{service.name}</SubTitle>
          <ButtonRow>
            {AuthService.hasPermission ('business_config.catalog', 'edit') && (
              <Button onClick={handleEdit}>
                <FaEdit color='#35A7FF' size={18}/>
              </Button>
            )}
            {AuthService.hasPermission ('business_config.catalog', 'delete') && (
              <Button onClick={toggleAlertDialog}>
                {deleting ? (
                  <ButtonLoading style={{margin: 0}}/>
                ) : (
                  <FaTrash color='#FF3939' size={16}/>
                )}
              </Button>
            )}
          </ButtonRow>
        </Header>
        <MoneyTextMask value={service.price}/>
        {service.description && (
          <Description>
            {service.description}
          </Description>
        )}
      </Info>
      <AlertDialog
        visible={showAlertDialog}
        title='Atenção!'
        message='Deseja realmente excluir este serviço do catálogo?'
        confirmText='Sim'
        cancelText='Não'
        onConfirm={deleteCatalogService}
        onClose={toggleAlertDialog}
        dangerous={true}
      />
    </Container>
  )
}
